export const SPIN_DURATION_MS = 5200;
